// extracted by mini-css-extract-plugin
module.exports = {"root":"styles-module--root--3MXX_","form":"styles-module--form--1jpTY","button":"styles-module--button--2CYZO"};